if (!customElements.get('ffn-faq-motion')) {
  customElements.define('ffn-faq-motion', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.animations = new Set();
      this.rotationTimer = null;
      this.rotationIndex = 0;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.section = this.closest('.ffn-faq');
      this.phrases = Array.from(this.section?.querySelectorAll('[data-faq-world-phrase]') || []);
      this.worldKeys = Array.from(this.section?.querySelectorAll('[data-faq-world-key]') || []);

      this.setupAccordions();
      this.setupWorldRotation();
    }

    setupAccordions() {
      this.querySelectorAll('details').forEach(details => {
        const summary = details.querySelector('summary');
        let expanded = details.open;
        let animation;
        summary.setAttribute('aria-expanded', String(expanded));
        details.classList.toggle('is-expanded', expanded);
        summary.addEventListener('click', event => {
          event.preventDefault();
          const start = details.getBoundingClientRect().height;
          if (animation) {
            animation.cancel();
            this.animations.delete(animation);
          }
          expanded = !expanded;
          details.classList.toggle('is-expanded', expanded);
          summary.setAttribute('aria-expanded', String(expanded));
          details.style.height = '';
          details.style.overflow = '';
          details.open = expanded;
          const end = details.getBoundingClientRect().height;
          if (this.reducedMotion.matches) return;
          details.open = true;
          details.style.overflow = 'hidden';
          animation = details.animate({ height: [`${start}px`, `${end}px`] }, {
            duration: 380,
            easing: 'cubic-bezier(.2,.75,.25,1)'
          });
          this.animations.add(animation);
          const current = animation;
          current.onfinish = () => {
            details.open = expanded;
            details.style.overflow = '';
            this.animations.delete(current);
            animation = null;
          };
        }, { signal: this.events.signal });
      });
    }

    setupWorldRotation() {
      if (!this.section || this.phrases.length < 2) return;

      this.renderWorld(0);
      this.handleVisibility = () => {
        if (document.hidden || this.reducedMotion.matches || !this.isVisible) {
          this.stopWorldRotation();
        } else {
          this.scheduleWorldRotation();
        }
      };
      document.addEventListener('visibilitychange', this.handleVisibility, { signal: this.events.signal });
      this.reducedMotion.addEventListener('change', this.handleVisibility, { signal: this.events.signal });

      this.observer = new IntersectionObserver(entries => {
        this.isVisible = entries.some(entry => entry.isIntersecting);
        this.handleVisibility();
      }, { rootMargin: '120px 0px', threshold: 0.08 });
      this.observer.observe(this.section);
    }

    scheduleWorldRotation() {
      if (this.rotationTimer || this.reducedMotion.matches || !this.isVisible) return;
      this.rotationTimer = window.setTimeout(() => {
        this.rotationTimer = null;
        this.renderWorld((this.rotationIndex + 1) % this.phrases.length);
        this.scheduleWorldRotation();
      }, 3400);
    }

    stopWorldRotation() {
      if (!this.rotationTimer) return;
      window.clearTimeout(this.rotationTimer);
      this.rotationTimer = null;
    }

    renderWorld(index) {
      this.rotationIndex = index;
      const activePhrase = this.phrases[index];
      const activeWorld = activePhrase.dataset.faqWorldPhrase;
      this.section.dataset.faqWorld = activeWorld;
      this.phrases.forEach((phrase, phraseIndex) => {
        const active = phraseIndex === index;
        phrase.classList.toggle('is-active', active);
        phrase.setAttribute('aria-hidden', String(!active));
      });
      this.worldKeys.forEach(key => {
        key.classList.toggle('is-active', key.dataset.faqWorldKey === activeWorld);
      });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.animations?.forEach(animation => animation.cancel());
      this.stopWorldRotation();
      this.observer?.disconnect();
    }
  });
}
